import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { Map } from 'immutable';
import is from 'is_js';
import { connect, log } from 'omni-common-ui';
import { actions as sessionPlansActions } from 'data/SessionPlans';
import PropTypes from 'prop-types';
import * as Session from 'data/SessionPlans/accessors';

export class MarkAttendance extends PureComponent {
  componentWillMount() {
    this._checkIsMarkableInMarkMode(this.props);
    this.props.fetchSessionPlansIfNeeded(this.props.params.groupId);
  }

  componentWillReceiveProps(nextProps) {
    this._checkIsMarkableInMarkMode(nextProps);
  }

  _checkIsMarkableInMarkMode(props) {
    const { markable, mode, buildRoute, replace } = props;

    if (is.boolean(markable) && ! markable && mode === 'edit') {
      log.warn('Session: not a markable session; leaving edit mode');
      return replace(buildRoute({ mode: '' }));
    }
  }

  render() {
    if (! is.existy(this.props.sessions)) {
      return null;
    }
    return <div>{this.props.children}</div>;
  }
}

MarkAttendance.getCurrentRouteSegment = ({ routes }) =>
  (routes ? routes[routes.length - 1] : {});

MarkAttendance.propTypes = {
  children: PropTypes.node,
  markable: PropTypes.bool,
  fetchSessionPlansIfNeeded: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  params: PropTypes.shape({
    groupId: PropTypes.string.isRequired,
  }).isRequired,
  sessions: PropTypes.object,
  mode: PropTypes.string,
};

export function mapStateToProps(state, ownProps) {
  const { groupId, sessionPlanId } = ownProps.params;
  const sessions = Session.getSessions(state, groupId);
  if (Map.isMap(sessions) && sessions.size !== 0) {
    return {
      markable: Session.isMarkable(state, groupId, sessionPlanId),
      sessions,
      mode: ownProps.mode,
    };
  }
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(sessionPlansActions, dispatch)
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MarkAttendance);



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/component.jsx